import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";
import { formatDate } from "../../../utils/formatDate";

export default function CssfPdfDiplomasSection( { resumeData, translations } ) {
    const { diplomas } = extractResumeDataDocumentSection( resumeData );
    const { isAnonymous } = extractResumeProperties( resumeData );
    const documentLanguage = 'fr'; // Forced for CSSF

    const styles = StyleSheet.create( {
        section: {
            flexDirection: 'row',
            marginBottom: 10,
            fontSize: 10,
        },
        textStart: {
            textAlign: 'start',
        },
        leftColumn: {
            width: '16%',
        },
        rightColumn: {
            width: '80%',
            marginLeft: 12,
        },
    } );

    return (
        <>
            <View style={ [ styles.section, { marginBottom: 0 } ] }>
                <View style={ [
                    styles.leftColumn,
                    { width: "30%", justifyContent: "flex-end", alignItems: "flex-end" }
                ] }>
                    <Text style={ [
                        styles.textStart,
                        {
                            fontFamily: "Verdana, sans-serif",
                            fontSize: "9px",
                            margin: 0,
                            color: "#009999",
                            marginTop: 4,
                            textAlign: "right",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            display: "flex"
                        }
                    ] }>
                        DIPLOMES/CERTIFICATIONS
                    </Text>
                </View>
                <View style={ [ styles.rightColumn, {
                    width: "70%",
                    justifyContent: "flex-end",
                    alignItems: "flex-end"
                } ] }>
                    <View style={ {
                        width: "100%",
                        height: 5,
                        backgroundColor: "#009999",
                        marginVertical: 4
                    } }/>
                </View>
            </View>
            { diplomas
                .filter( ( diploma ) => diploma.from && ( diploma.to || diploma.isCurrent ) )
                .sort( ( a, b ) => a.order - b.order )
                .map( ( diploma, index ) => (
                    <View style={ [ styles.section, { marginBottom: 8 } ] } wrap={ false }>
                        <View style={ [ styles.leftColumn, {
                            width: "30%",
                            justifyContent: "flex-start",
                            alignItems: "flex-end"
                        } ] }>
                            <Text key={ `formation-${ index }` } style={ [
                                styles.textStart,
                                {
                                    fontFamily: "Verdana, sans-serif",
                                    fontSize: "9px",
                                    margin: 0,
                                    color: "#009999",
                                    marginTop: 4,
                                    textAlign: "right",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-start",
                                    display: "flex"
                                }
                            ] }>
                                { formatDate( diploma.from, documentLanguage ) }
                                { ' au ' }
                                { diploma.isCurrent ? translations.pdf.isCurrentLabel : formatDate( diploma.to, documentLanguage ) }
                                { ' ' }
                                { diploma.location }
                            </Text>
                        </View>
                        <View style={ [
                            styles.rightColumn,
                            {
                                width: "70%",
                                justifyContent: "flex-start",
                                alignItems: "flex-start"
                            }
                        ] }>
                            <Text style={ {
                                fontSize: 11,
                                fontFamily: "Verdana, sans-serif",
                                color: "#3F3A38",
                                marginTop: 4
                            } }>
                                { diploma.diplomaTitle }{ ' ' }
                            </Text>
                            <Text style={ {
                                fontSize: 9,
                                fontFamily: "Verdana, sans-serif",
                                color: "#3F3A38",
                                marginTop: 4
                            } }>
                                { isAnonymous ? translations.pdf.diplomasSchoolLabel : diploma.schoolName }
                            </Text>
                        </View>
                    </View>
                ) ) }
        </>
    );
}
